import { CancelablePromise, apiRequest } from '../../../main/services/api'
import { ActionTypes } from '../constants/constants'
import AppDispatcher from '../dispatcher/appDispatcher'
import BubbleStore from '../stores/bubbleStore'
import { BubbleNode, BubblesLoadParam, Range } from '../types'
import { encodeQueryString } from '../utils'

let _lastRequest: CancelablePromise<any> | null = null

const actions = {
  async load(url: string, params: BubblesLoadParam) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.LOAD_DATA_STARTED,
      params: params,
    })

    _lastRequest?.cancel?.()
    _lastRequest = apiRequest(url, { query: params }, true)
    try {
      const data = await _lastRequest
      AppDispatcher.handleServerAction({
        type: ActionTypes.LOAD_DATA_COMPLETED,
        data,
      })
    } catch (error) {
      AppDispatcher.handleServerAction({
        type: ActionTypes.LOAD_DATA_FAILED,
        errorStatus: (error as { status: string }).status,
      })
    }
  },

  changeRange(type: string, range: Range) {
    if (range.min > range.max) {
      var temp = range.min
      range.min = range.max
      range.max = temp
    }

    AppDispatcher.handleViewAction({
      type: ActionTypes.CHANGE_RANGE,
      rangeType: type,
      range,
    })

    window.history?.replaceState?.(
      {},
      document.title,
      `${window.location.pathname}?` + encodeQueryString(BubbleStore.getParams())
    )
  },

  setHoveredNode(node?: BubbleNode) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.SET_HOVERED_NODE,
      node: node,
    })
  },

  setHoveredColor(color: string | null) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.SET_HOVERED_COLOR,
      color: color,
    })
  },
}

export default actions
